import { RouteConfig } from 'vue-router';

const MyReport = () => import(/* webpackChunkName: "Dig" */  './views/my-report/my-report.vue');
const DetailReport = () => import(/* webpackChunkName: "Dig" */  './views/report-detail/report-detail.vue');
const TongueFolder = () => import(/* webpackChunkName: "Dig" */  './modules/tongue/tongue-folder.vue');
const TongueResult = () => import(/* webpackChunkName: "Dig" */  './modules/tongue/tongue-result.vue');
const ExpertBianzheng = () => import(/* webpackChunkName: "Dig" */  './modules/expert/bianzheng/bianzheng.vue');
const ExpertYongyao = () => import(/* webpackChunkName: "Dig" */  './modules/expert/yongyao/yongyao.vue');
const ExpertFolder = () => import(/* webpackChunkName: "Dig" */  './modules/expert/expert-folder.vue');
const ExpertResult = () => import(/* webpackChunkName: "Dig" */  './modules/expert/expert-result.vue');
const CustomAnalysis = () => import(/* webpackChunkName: "Dig" */  './modules/custom/custom-analysis.vue');
const CustomFolder = () => import(/* webpackChunkName: "Dig" */  './modules/custom/custom-folder.vue');




const routers: RouteConfig[] = [
    {
        path: 'my-report',
        component: MyReport
    },
    {
        path: 'report-detail/:report_id',
        component: DetailReport
    },
    {
        path: "tongue-folder",
        component: TongueFolder
    },
    {
        path: "tongue-result",
        component: TongueResult
    },
    {
        path: 'expert-bianzheng',
        component: ExpertBianzheng
    },
    {
        path: 'expert-yongyao',
        component: ExpertYongyao
    },
    {
        path: 'expert-folder',
        component: ExpertFolder
    },
    {
        path: 'expert-result',
        component: ExpertResult
    },
    {
        path: 'custom-analysis',
        component: CustomAnalysis
    },
    {
        path: 'custom-folder',
        component: CustomFolder
    },
    {
        path: '',
        redirect: 'tongue-quality'
    },
];

export default routers;

